import { RegistrationCPGResponse } from '../../models/registration-cpg/registration-cpg-response.interface';

export const mockRegistrationCPGResponse: RegistrationCPGResponse = {
  productTitle: 'everydropÂ® Refrigerator Water Filter 3 - EDR3RXD1',
  filter: 'EDR3RXD1',
  disclaimer:
    '*Automatic subscription discount taken off regular price excluding taxes and shipping. 1-pack of Filter 1, 2, 3, 4 and 5 are $48.00 for refills, 1-Pack of Filter 6 & Ice Filter are $40.00 for refills, 2-pack of Filter  1, 2, 3, 4 and 5 are $86.39 for refills, 2-pack of Filter 6 are $71.99 for refills.  Only valid for new subscription orders on everydropwater.com. Offer subject to change. No cash value. See subscription terms for details. **Shipped to a single U.S. address. Excludes in-home and express delivery. Only valid for new orders on everydropwater.com.',
  description:
    'Subscribe to receive additional 10% off your first filter & 20% off refills with code WATERDG10* + Free Shipping**\n\nAuto-refills unless canceled. See disclaimer for exact refill pricing',
  waterFilterUrl:
    'https://www.everydropwater.com/water-filter.refrigerator-water-and-ice-filter-3.edr3rxd1.html',
  cta: 'Shop Now',
  title:
    "Don't forget to add the only filter approved by WhrilpoolÂ® for your refrigerator",
  promoCode: 'WATERDG10',
};
